import { FC } from 'react'
import styles from './AltTableOfContentsHeading.module.css'
import { BasicStyledComponent } from 'shared-definitions/types'
import clsx from 'clsx'

interface AltTableOfContentsHeadingProps extends BasicStyledComponent {
  title: string
}

const AltTableOfContentsHeading: FC<AltTableOfContentsHeadingProps> = ({ title, className }) => (
  <div className={clsx(styles.heading, className)}>
    <div className={styles.title}>{title}</div>
    <button
      type="button"
      className={styles.toTopButton}
      onClick={() => {
        document.body.scrollIntoView({ behavior: 'smooth' })
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.625 11.0416C15.625 11.3868 15.3451 11.6666 15 11.6666C14.6548 11.6666 14.375 11.3868 14.375 11.0416V5.46713L12.7336 7.10852C12.4895 7.3526 12.0938 7.3526 11.8497 7.10852C11.6056 6.86445 11.6056 6.46872 11.8497 6.22464L14.5581 3.51631C14.8021 3.27223 15.1978 3.27223 15.4419 3.51631L18.1502 6.22464C18.3943 6.46872 18.3943 6.86445 18.1502 7.10852C17.9061 7.3526 17.5105 7.3526 17.2664 7.10852L15.625 5.46713V11.0416ZM2.5 4.79159C2.5 4.44641 2.77983 4.16659 3.125 4.16659H7.70833C8.05351 4.16659 8.33333 4.44641 8.33333 4.79159C8.33333 5.13676 8.05351 5.41659 7.70833 5.41659H3.125C2.77983 5.41659 2.5 5.13676 2.5 4.79159ZM3.125 9.37492C2.77983 9.37492 2.5 9.65475 2.5 9.99992C2.5 10.3451 2.77983 10.6249 3.125 10.6249H9.375C9.72017 10.6249 10 10.3451 10 9.99992C10 9.65475 9.72017 9.37492 9.375 9.37492H3.125ZM3.125 14.5833C2.77983 14.5833 2.5 14.8631 2.5 15.2083C2.5 15.5534 2.77983 15.8333 3.125 15.8333H15.2083C15.5535 15.8333 15.8333 15.5534 15.8333 15.2083C15.8333 14.8631 15.5535 14.5833 15.2083 14.5833H3.125Z"
          fill="black"
        />
      </svg>
    </button>
  </div>
)

export default AltTableOfContentsHeading
